import { X } from 'lucide-react'

interface ConfirmDeleteDraftModalProps {
  readonly open: boolean
  readonly conversationId?: number | null
  readonly onCancel: () => void
  readonly onConfirm: () => void
  readonly isLoading?: boolean
}

export function ConfirmDeleteDraftModal({
  open,
  conversationId,
  onCancel,
  onConfirm,
  isLoading,
}: ConfirmDeleteDraftModalProps) {
  if (!open) return null

  const idText = conversationId != null ? `#${conversationId}` : '#—'

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-3 md:p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-delete-draft-title"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-[calc(100vw-1.5rem)] rounded-xl bg-white shadow-xl md:max-w-md"
        onClick={(e) => e.stopPropagation()}
        role="document"
      >
        <div className="flex items-center justify-between border-b border-gray-200 px-4 py-4 md:px-5">
          <h2 id="confirm-delete-draft-title" className="text-lg font-semibold text-gray-900">
            Eliminar conversa
          </h2>
          <button
            type="button"
            onClick={onCancel}
            className="rounded-md p-1 text-gray-500 hover:bg-gray-100"
            aria-label="Fechar"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-4 md:p-5">
          <p className="text-sm text-gray-700">
            Quer eliminar o rascunho da conversa <span className="font-semibold">{idText}</span>?
          </p>

          <div className="mt-5 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
            <button
              type="button"
              onClick={onCancel}
              disabled={isLoading}
              className="w-full rounded-md border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50 sm:w-auto"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isLoading}
              className="w-full rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 disabled:opacity-50 sm:w-auto"
            >
              {isLoading ? 'A eliminar…' : 'Eliminar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

